import type { SafetyMeetingLiveAttendanceMeetingSnapshot } from "@miter/types/common";

import { formatMeetingDate } from "safety/components/attendance/format";

export const MeetingHeader = ({
  snapshot,
}: {
  snapshot: SafetyMeetingLiveAttendanceMeetingSnapshot;
}): React.JSX.Element => (
  <div className="tw:border-b tw:border-stroke tw:p-5">
    <div className="tw:text-xs tw:font-medium tw:uppercase tw:tracking-wide tw:text-midnight/50">
      {snapshot.company_name} · Safety Meeting
    </div>
    <h1 className="tw:m-0 tw:mt-1 tw:text-2xl tw:font-denim tw:text-midnight">{snapshot.meeting_name}</h1>
    <div className="tw:mt-2 tw:flex tw:flex-col tw:gap-0.5 tw:text-sm tw:text-midnight/70">
      <span>{formatMeetingDate(snapshot.date)}</span>
      {snapshot.job_name && <span>{snapshot.job_name}</span>}
      {snapshot.supervisor_name && <span>Run by {snapshot.supervisor_name}</span>}
    </div>
  </div>
);
